type OneSignalEventProperties = Record<
  string,
  string | number | boolean | null | undefined
>;

const pendingEnsures = new Set<string>();

const oneSignalUserStorageKey = (sub: string) => `postdrop_onesignal_user:${sub}`;

export const ensureOneSignalUser = (sub?: string | null) => {
  if (typeof window === "undefined" || !sub || pendingEnsures.has(sub)) {
    return;
  }

  const storageKey = oneSignalUserStorageKey(sub);

  try {
    if (window.localStorage.getItem(storageKey)) {
      return;
    }
  } catch (_error) {
    return;
  }

  pendingEnsures.add(sub);

  void fetch("/api/onesignal/ensure-user", {
    method: "POST",
    credentials: "same-origin",
  })
    .then((response) => {
      if (!response.ok) {
        pendingEnsures.delete(sub);
        return;
      }

      try {
        window.localStorage.setItem(storageKey, "1");
      } catch (_error) {
        pendingEnsures.delete(sub);
      }
    })
    .catch(() => {
      pendingEnsures.delete(sub);
    });
};

export const trackOneSignalCustomEvent = async (
  eventName: string,
  eventProperties: OneSignalEventProperties = {}
) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    const response = await fetch("/api/onesignal/custom-events", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        eventName,
        eventProperties,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("[OneSignal] Failed to track custom event:", errorText);
      return;
    }

    const payload = await response.json();

    if (payload?.errors?.length) {
      console.warn("[OneSignal] Custom event accepted with item errors:", payload.errors);
    }
  } catch (error) {
    console.error("[OneSignal] Failed to track custom event:", error);
  }
};
